import commissionSalesGroupsServiceGen from "./generated/commissionSalesGroupsServiceGen";

class commissionSalesGroupsService extends commissionSalesGroupsServiceGen {
}

export default commissionSalesGroupsService;